<template>
  <page-list
    :list="list"
    :columns="columns"
    :singleActions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import * as R from 'ramda'
import { mapState } from 'vuex'
import { currencyUnitMap } from '@/constants/currency'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'BillExchangeRateList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_exchange_rates/month-group',
        apiVersion: 'v1',
        idKey: 'month',
        getParams: { details: true, group_by: 'enable_date' },
      }),
      columns: [
        {
          field: 'month',
          title: this.$t('bill.effective_month'),
          formatter: ({ row }) => {
            const month = row.month + ''
            return `${month.substring(0, 4)}-${month.substring(4, 6)}`
          },
        },
        {
          field: 'items',
          title: this.$t('bill.exchange_rate'),
          slots: {
            default: ({ row }) => {
              const items = R.clone(row.items || [])
              if (!items.length) return '-'
              items.sort((a, b) => {
                if (a.src === b.src) {
                  return b.dest && b.dest.localeCompare(a.dest)
                }
                return b.src && b.src.localeCompare(a.src)
              })
              return items.map((item) => {
                const tagText = `${currencyUnitMap[item.src]?.sign ?? item.src}1 = ${currencyUnitMap[item.dest]?.sign ?? item.dest}${item.rate}`
                return <span class="tag d-inline-block">{tagText}</span>
              })
            },
          },
        },
      ],
      singleActions: [
        {
          label: this.$t('bill.text_165'),
          action: obj => {
            this.$router.push({
              name: 'BillExchangeRateCreate',
              params: obj,
            })
          },
        },
      ],
      exportDataOptions: {
        items: [
          { label: this.$t('bill.text_40'), key: 'start_date' },
          { label: this.$t('bill.text_41'), key: 'end_date' },
          { label: this.$t('bill.text_89'), key: 'status' },
          { label: this.$t('bill.exchange_rate'), key: 'items' },
        ],
      },
    }
  },
  computed: {
    ...mapState('common', {
      currencyOpts: state => state.bill.currencyOpts,
    }),
    canSetNewExchangeRate () {
      const currencyList = []
      this.currencyOpts.map(item => {
        const cur = item.item_id.replace('_', '').replace('*', '')
        if (currencyList.indexOf(cur) === -1) currencyList.push(cur)
      })
      return currencyList.length > 1
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
  },
}
</script>
<style scoped>
.tag{
  margin: 3px 10px 3px 0;
  padding: 3px 10px;
  font-size: 12px;
  border: solid 1px #ccc;
}
</style>
